import { render, staticRenderFns } from "./input-curency.vue?vue&type=template&id=59008338&scoped=true&"
import script from "./input-curency.vue?vue&type=script&lang=js&"
export * from "./input-curency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59008338",
  null
  
)

export default component.exports